export enum Interval {
  HOUR,
  DAY,
  WEEK,
  MONTH
}